module.exports = __webpack_public_path__ + "static/media/funnel.43f479b3.svg";